export const STORE_BADGE_FALLBACK_LOCALE = 'en-AU'

function sameLanguageBadge(base: string, available: ReadonlySet<string>): string | undefined {
  const requested = new Intl.Locale(base)
  const script = requested.maximize().script
  const matches = [...available].filter(candidate => {
    const parsed = new Intl.Locale(candidate)
    if (parsed.language !== requested.language) return false
    // zh-HK must not reuse the simplified zh-CN artwork.
    return !script || parsed.maximize().script === script
  })

  const canonical = `${requested.language}-${requested.language.toUpperCase()}`
  if (matches.includes(canonical)) return canonical
  if (matches.includes(STORE_BADGE_FALLBACK_LOCALE)) return STORE_BADGE_FALLBACK_LOCALE

  matches.sort()
  return matches[0]
}

export function resolveStoreBadgeLocale(
  locale: string | undefined,
  available: ReadonlySet<string>,
): string {
  const normalised = (locale || STORE_BADGE_FALLBACK_LOCALE).replace(/_/g, '-')
  // Arabic `intl.locale` is `ar-SA-u-nu-latn` so numbers stay Western digits.
  const base = new Intl.Locale(normalised).baseName
  if (available.has(base)) return base
  if (available.has(normalised)) return normalised

  return sameLanguageBadge(base, available) ?? STORE_BADGE_FALLBACK_LOCALE
}
